import { castOptions } from '../../../../config/facilitatorValidationConfiguration';

export const castFunctionHelper = (key, defaultState, action) => {
  const castFunction = castOptions[key];

  if (action.payload[key] != null) {
    return castFunction(action.payload[key], defaultState);
  }

  return defaultState;
};
